import supabase from './supabaseconnect';
import moment from 'moment';

export async function bulk_claim_upload_api(req_data){
    // await supabase.storage.from('bucket').remove(['object-key-1', 'object-key-2'])
    var json_data = {"claim":req_data.record}
/*
    var d = req_data.record;

    console.log(json_data);

    const sortedClaims = d.sort((a, b) => {
        if (!a.InvoiceNo) return 1;
        if (!b.InvoiceNo) return -1;

        // Compare InvoiceNo first
        if (a.InvoiceNo < b.InvoiceNo) return -1;
        if (a.InvoiceNo > b.InvoiceNo) return 1;

        // If InvoiceNo is the same, compare RepCode
        if (a.RepCode < b.RepCode) return -1;
        if (a.RepCode > b.RepCode) return 1;

        return 0;
    });

    let claim_data = [];

    let final_data = [];

    for(let i=0;i<sortedClaims.length;i++){
        if(sortedClaims[i].InvoiceNo != '' && sortedClaims[i].InvoiceNo != undefined && sortedClaims[i].InvoiceNo != null && sortedClaims[i].InvoiceNo != 'undefined' && (sortedClaims[i].InvoiceNo.toString().trim()) != ''){
            if(i == 0){
                claim_data.push(sortedClaims[i]);
            }else{
                if(sortedClaims[i].InvoiceNo == sortedClaims[i-1].InvoiceNo){
                    claim_data.push(sortedClaims[i]);
                }else{
                    if(claim_data.length > 0){
                        final_data.push({"req_data": {"claim": claim_data}});
                    }

                    claim_data = [];
                    claim_data.push(sortedClaims[i]);
                }
            }
        }

        if(i == sortedClaims.length-1){
            if(claim_data.length > 0){
                final_data.push({"req_data": {"claim":claim_data}});
            }
        }
    }
*/
    var file_name = moment().format('YYYY-MM-DD HH:mm:ss:SSS') +" - "+ req_data.file_name;
    console.log(file_name);

    var { error } = await supabase.auth.refreshSession();

    const { data: { user } } = await supabase.auth.getUser()

    var user_id = user.id;

    var { data, error } =await supabase.from('user').select('*').eq('user_id',user_id).eq('role','0');

    if(error){
        var resepnse_data = {"success":false,"msg":error.message}
        return(resepnse_data);
    }else
    {
        if(data.length > 0){
            var { data, error } =await supabase.from('temp_bulk_upload').insert({req_data: json_data,file_name:file_name});

            if(error){
                var resepnse_data = {"success":false,"msg":error.message}
                return(resepnse_data);
            }else
            {
                if(req_data.upload_file != '' && req_data.upload_file != undefined && req_data.upload_file != null && req_data.upload_file != 'undefined'){
                    const file_path = "upload/"+file_name;
                    var { data, error } = await supabase.storage.from('BulkClaimUpload').upload(file_path, req_data.upload_file)
                    if (error) {
                        var resepnse_data = {"success":false,"msg":error.message}
                        return(resepnse_data);
                    } else {
                        var resepnse_data = {"success":true,"msg":'Claim Upload Started Successfully'}
                        return(resepnse_data);
                    }
                }
            }
        }else{
            var resepnse_data = {"success":false,"msg":'Admin changed your access.Please Contact admin.'}
            return(resepnse_data);
        }
    }
}